import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchOrder,
  fetchOrders,
} from "../../actions/callrecorder/ordersActions";

export interface OrderInterface {
  url: string;

  id: number;
  user_id: number;
  product_id: number | null;
  productid: string | null;
  status: string;
  transaction_id: string;
  amount: string | null;
  price: string | null;
  code: number | null;
  message: string | null;
  receipt: string;
  version: number | null;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<OrderInterface>();

const slice = createSlice({
  name: 'orders',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchOrders.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.orders;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchOrder.fulfilled, (state, action) => {
        const order = Object.values(action.payload.order)[0];
        state.entities[order.id] = order;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectOrderById,
  selectIds: selectOrderIds,
  selectEntities: selectOrderEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.orders);
